import {
  dateRange,
  isEqual,
  isValidIban,
  phoneValidator,
  requiredAll,
  requiredIf,
} from './';
import { maxOneDecimal } from './max-one-decimal.validator';

export class CustomValidators {
  static requiredIf = requiredIf;
  static requiredAll = requiredAll;
  static isEqual = isEqual;
  static isValidIban = isValidIban;
  static phoneValidator = phoneValidator;
  static dateRange = dateRange;
  static maxOneDecimal = maxOneDecimal;
}
